import axios from "axios";
import { apiKey } from "../../store";
import {
  SET_PHASE,
  SET_OPTIONS,
  SET_SELECTED,
  TOGGLE_SECTION,
  SET_ERROR,
  SET_RESULT,
  RESET_BACKUP,
  SET_LAST_BACKUP_TIME,
} from "./backupType";

const apiKeyBackup = apiKey + "lawyer/users";

const FALLBACK_LABELS = {
  profile: "پروفایل",
  lawsuits: "پرونده‌ها",
  contacts: "مخاطبین",
  notes: "یادداشت‌ها",
  events: "رویدادها",
  financials: "امور مالی",
  bayganis: "بایگانی‌ها",
};

const normalizeSections = (raw) => {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item) => {
      const key = item?.key || item?.id || item?.section || item?.name;
      if (!key) return null;
      const label = item?.label || item?.title || FALLBACK_LABELS[key] || key;
      const count = item?.count ?? item?.total ?? 0;
      return { key, label, count };
    })
    .filter(Boolean);
};

const authConfig = (authToken, extra = {}) => ({
  headers: {
    "Auth-Token": authToken,
    "X-Auth-Token": authToken,
    header_app_type: "lawyer",
  },
  timeout: 15000,
  ...extra,
});

export const getOptionsHandler = (authToken, userId) => {
  return async (dispatch) => {
    dispatch({ type: SET_PHASE, payload: "loading" });
    dispatch({ type: SET_ERROR, payload: "" });
    try {
      const response = await axios.get(
        `${apiKeyBackup}/${userId}/backup/options`,
        authConfig(authToken),
      );
      if (response.data.status === "success") {
        const sections = normalizeSections(
          response.data.data.available_sections,
        );
        dispatch({ type: SET_OPTIONS, payload: sections });
        dispatch({
          type: SET_LAST_BACKUP_TIME,
          payload: response.data.data.last_backup,
        });

        dispatch({
          type: SET_SELECTED,
          payload: sections
            .filter((s) => s.key !== "profile")
            .map((s) => s.key),
        });
        dispatch({ type: SET_PHASE, payload: "ready" });
      } else {
        dispatch({
          type: SET_ERROR,
          payload: response.data.message || "دریافت اطلاعات با خطا مواجه شد.",
        });
        dispatch({ type: SET_PHASE, payload: "error" });
      }
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: "ارتباط با سرور برقرار نشد. اتصال اینترنت خود را بررسی کنید.",
      });
      dispatch({ type: SET_PHASE, payload: "error" });
    }
  };
};

export const toggleSectionAction = (key) => ({
  type: TOGGLE_SECTION,
  payload: key,
});

export const resetBackupAction = () => ({ type: RESET_BACKUP });

export const exportBackupHandler = (authToken, userId, sections) => {
  return async (dispatch) => {
    dispatch({ type: SET_PHASE, payload: "generating" });
    dispatch({ type: SET_ERROR, payload: "" });
    try {
      const response = await axios.post(
        `${apiKeyBackup}/${userId}/backup/export`,
        { sections },
        authConfig(authToken, { timeout: 30000 }),
      );

      if (response.data.status === "success") {
        const filename =
          response.data.data?.filename ||
          response.data.data?.file ||
          response.data.data?.file_name;

        if (!filename) {
          dispatch({
            type: SET_ERROR,
            payload: "پاسخ سرور نامعتبر بود؛ نام فایل پشتیبان دریافت نشد.",
          });
          dispatch({ type: SET_PHASE, payload: "error" });
          return null;
        }

        dispatch({ type: SET_RESULT, payload: filename });
        return filename;
      }

      dispatch({
        type: SET_ERROR,
        payload: response.data.message || "ساخت فایل پشتیبان با خطا مواجه شد.",
      });
      dispatch({ type: SET_PHASE, payload: "error" });
      return null;
    } catch (error) {
      const status = error?.response?.status;
      let msg = "ارتباط با سرور برقرار نشد. اتصال اینترنت خود را بررسی کنید.";
      if (status === 409 || status === 429) {
        msg =
          "شما امروز قبلاً یک‌ بار پشتیبان‌گیری کرده‌اید. این امکان روزی یک‌ بار قابل استفاده است.";
      } else if (status === 403) {
        msg =
          "تعداد پرونده‌های شما کم است. این امکان فقط برای بیش از ۵ پرونده فعال می‌شود.";
      } else if (error?.response?.data?.message) {
        msg = error.response.data.message;
      }
      dispatch({ type: SET_ERROR, payload: msg });
      dispatch({ type: SET_PHASE, payload: "error" });
      return null;
    }
  };
};

export const downloadBackupHandler = (authToken, userId, filename) => {
  return async (dispatch) => {
    dispatch({ type: SET_PHASE, payload: "downloading" });
    try {
      const response = await axios.get(
        `${apiKeyBackup}/${userId}/backup/download/${filename}`,
        authConfig(authToken, { responseType: "blob", timeout: 30000 }),
      );

      const blobUrl = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);

      dispatch({ type: SET_PHASE, payload: "done" });
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: "دانلود فایل پشتیبان با خطا مواجه شد. لطفاً دوباره تلاش کنید.",
      });
      dispatch({ type: SET_PHASE, payload: "error" });
    }
  };
};
